function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCrownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.858 26H23.14l1.328-8.633-3.655 4.339a1 1 0 01-1.632-.147L16 16.009l-3.182 5.55a1 1 0 01-1.632.147l-3.657-4.34L8.858 26zM24 28H8a1 1 0 01-.99-.848l-2-13a1 1 0 011.754-.797l5.03 5.969 3.338-5.821c.356-.623 1.379-.623 1.735 0l3.339 5.82 5.029-5.968a1 1 0 011.753.797l-2 13A1 1 0 0124 28zM6 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm10-6c-1.104 0-2 .897-2 2s.896 2 2 2c1.102 0 2-.897 2-2s-.898-2-2-2zm0 6c-2.207 0-4-1.794-4-4s1.793-4 4-4c2.206 0 4 1.794 4 4s-1.794 4-4 4zm10-6c-1.104 0-2 .897-2 2s.896 2 2 2c1.102 0 2-.897 2-2s-.898-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: props.color
  }));
}

export default SvgIconCrownFilled;